import { render } from "./DetailPageRecommed.vue?vue&type=template&id=93706d26"
import script from "./DetailPageRecommed.vue?vue&type=script&lang=js"
export * from "./DetailPageRecommed.vue?vue&type=script&lang=js"

import "./DetailPageRecommed.vue?vue&type=style&index=0&id=93706d26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__